import { ServicePriceService } from 'api-new/generated/services/ServicePriceService';
import { QueryError } from 'features/shared/model';
import { UseQueryOptions, useQuery } from 'react-query';

export const useGetManufacturersQueryKey = 'useGetManufacturersQueryKey';

const fetchManufacturers = async () => {
  const data = await ServicePriceService.getServicePriceGetManufacturers();
  const sortedData = data.sort((a, b) => (a.id ?? Number.MAX_VALUE) - (b.id ?? Number.MAX_VALUE));
  return {
    data: sortedData
  };
};

export const useGetManufacturersQuery = <TQueryKey extends Array<unknown> = unknown[]>(
  queryKey?: TQueryKey,
  options?: Omit<
    UseQueryOptions<
      Awaited<ReturnType<typeof fetchManufacturers>>,
      QueryError,
      Awaited<ReturnType<typeof fetchManufacturers>>,
      unknown[]
    >,
    'queryKey' | 'queryFn' | 'initialData'
  >
) =>
  useQuery([fetchManufacturers, ...((queryKey as unknown as TQueryKey) ?? [])], () => fetchManufacturers(), {
    ...options
  });
